(function () {
   if (document.body.classList.contains('template-index')) return;
  if (window.matchMedia('(min-width: 990px)').matches) return;

  function initMobileImageSwap() {
    document.querySelectorAll('.card-wrapper').forEach(function (wrapper) {
      if (wrapper.dataset.mobileSwapInit) return;
      wrapper.dataset.mobileSwapInit = 'true';

      var card = wrapper.querySelector('.card');
      if (!card) return;

      var secondImg = card.querySelector('.media.media--hover-effect > img + img');
      if (!secondImg) return;

      var touchStartX = 0;
      var touchStartY = 0;
      var intentDetermined = false;

      wrapper.addEventListener('touchstart', function (e) {
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
        intentDetermined = false;
      }, { passive: true });

      wrapper.addEventListener('touchmove', function (e) {
        if (intentDetermined) return;

        var deltaX = e.touches[0].clientX - touchStartX;
        var deltaY = e.touches[0].clientY - touchStartY;
        var absDeltaX = Math.abs(deltaX);
        var absDeltaY = Math.abs(deltaY);

        if (absDeltaX < 8 && absDeltaY < 8) return;

        intentDetermined = true;

        if (absDeltaX > absDeltaY) {
          // Swipe horizontal
          e.preventDefault();

          if (deltaX < 0) {
            // Swipe izquierda → segunda imagen
            card.classList.add('card--media-swap');
          } else {
            // Swipe derecha → primera imagen
            card.classList.remove('card--media-swap');
          }
        }
        // Vertical → scroll normal, sin tocar
      }, { passive: false });

      wrapper.addEventListener('touchend', function () {
        intentDetermined = false;
      }, { passive: true });
    });
  }

  initMobileImageSwap();

  document.addEventListener('shopify:section:load', initMobileImageSwap);

  var observer = new MutationObserver(initMobileImageSwap);
  observer.observe(document.body, { childList: true, subtree: true });
})();
